import { analytics_api } from "common/services/EnvironmentService";
import { postCall } from "./Api.service";



let pixelId: string = window.merchantInfo?.fbpixel || '',
  order_channel: string = window.merchantInfo?.platform || 'web';

export const logEvent = async (obj, beaconCall: boolean = false, optionalArg: any = {}) => {
    let url = analytics_api();
    let timestamp = Date.now();
    let userAgent = navigator.userAgent;
    const body = piiSanitize({
      ...obj,
      timestamp,
      userAgent,
      version: '1',
      order_channel,
      pixelId,
      abc_flag: optionalArg.isAbandonCart || false,
      ...(optionalArg.sourceValue ? { source: optionalArg.sourceValue } : {}),
      ...(optionalArg.requestId ? { requestId: optionalArg.requestId } : {}),
      ...(optionalArg.mid ? { merchantId: optionalArg.mid } : {}),
      ...(optionalArg.sessionId ? { sessionId: optionalArg.sessionId } : {}),
      ...(optionalArg._fbc ? { _fbc: optionalArg._fbc } : {}),
      ...(optionalArg._fbp ? { _fbp: optionalArg._fbp } : {}),
      ...(optionalArg.shopifySessionId ? { shopifySessionId: optionalArg.shopifySessionId } : {}),
      ...(optionalArg.shopifyCookieInfo ? { shopifyCookieInfo: optionalArg.shopifyCookieInfo } : {}),
    });
  
    if (body.name === 'merchant_unhealthy') {
      let cookies = {};
      document.cookie.split(';').forEach(function (el) {
        let [key, value] = el.split('=');
        cookies[key.trim()] = value;
      });
      !body.shopifySessionId && (body.shopifySessionId = cookies['_shopify_s'] || 'NA');
      !body.requestId && (body.requestId = body.shopifySessionId || 'NA');
      !body.merchantId && (body.merchantId = window.merchantInfo?.mid || 'NA');
    }
  
    if (beaconCall) {
      const headers = {
        type: 'application/json',
      };
      const blob = new Blob([JSON.stringify(body)], headers);
      navigator.sendBeacon(url, blob);
    } else {
      postCall(url, body);
    }
};



function piiSanitize(obj) {
    const keysToRemove = [
      'firstname',
      'lastname',
      'first_name',
      'last_name',
      'firstName',
      'lastName',
      'phone',
      'phoneNumber',
      'email',
      'address',
      'address1',
      'address2',
    ];
    if (obj?.name?.includes('trackFbStep') || obj?.name?.includes('trackSnapchatStep')) {
      return obj;
    }
  
    function removeKeys(target) {
      if (typeof target !== 'object' || target === null) {
        return target;
      }
  
      if (Array.isArray(target)) {
        return target.map(removeKeys);
      }
  
      const result = {};
      for (const key of Object.keys(target)) {
        if (!keysToRemove.includes(key) || (keysToRemove.includes(key) && typeof target[key] == 'object')) {
          result[key] = removeKeys(target[key]);
        }
      }
      return result;
    }
  
    return removeKeys(obj);
}

export const shopifyRedirectEvent = () => {
  const merchantUrl = getMerchantUrl();
  window.parent.postMessage({ type: 'shopifyRedirect', url: `${merchantUrl}/cart/checkout` }, merchantUrl);
};

export const appCallback = (response) => {
  const merchantUrl = getMerchantUrl();
  window.parent.postMessage({ type: 'appCallback', response }, merchantUrl);
};

export const stabilityEvent = (data: any, optionalArg: any = {}) => {
    logEvent({
      ...data,
      name: 'checkout_event',
      type: 'event',
      eventType: 'stabilityEvent',
    }, false, optionalArg);
};

const getMerchantUrl = (): string => {
    return `${window.location.protocol}//${window.location.host}`;
};

  